/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { PaginatedProductHeatPumpList } from '../models/PaginatedProductHeatPumpList';
import type { PatchedProductHeatPump } from '../models/PatchedProductHeatPump';
import type { ProductHeatPump } from '../models/ProductHeatPump';

import type { CancelablePromise } from '../core/CancelablePromise';
import type { BaseHttpRequest } from '../core/BaseHttpRequest';

export class ProductsHeatPumpService {

    constructor(public readonly httpRequest: BaseHttpRequest) {}

    /**
     * @returns PaginatedProductHeatPumpList
     * @throws ApiError
     */
    public productsHeatPumpList({
        page,
        pageSize,
        search,
    }: {
        /**
         * A page number within the paginated result set.
         */
        page?: number,
        /**
         * Number of results to return per page.
         */
        pageSize?: number,
        /**
         * A search term.
         */
        search?: string,
    }): CancelablePromise<PaginatedProductHeatPumpList> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/products-heat-pump/',
            query: {
                'page': page,
                'page_size': pageSize,
                'search': search,
            },
        });
    }

    /**
     * @returns ProductHeatPump
     * @throws ApiError
     */
    public productsHeatPumpCreate({
        requestBody,
    }: {
        requestBody: ProductHeatPump,
    }): CancelablePromise<ProductHeatPump> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/products-heat-pump/',
            body: requestBody,
            mediaType: 'application/json',
        });
    }

    /**
     * @returns ProductHeatPump
     * @throws ApiError
     */
    public productsHeatPumpRetrieve({
        id,
    }: {
        /**
         * A unique integer value identifying this product heat pump.
         */
        id: number,
    }): CancelablePromise<ProductHeatPump> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/products-heat-pump/{id}/',
            path: {
                'id': id,
            },
        });
    }

    /**
     * @returns ProductHeatPump
     * @throws ApiError
     */
    public productsHeatPumpUpdate({
        id,
        requestBody,
    }: {
        /**
         * A unique integer value identifying this product heat pump.
         */
        id: number,
        requestBody: ProductHeatPump,
    }): CancelablePromise<ProductHeatPump> {
        return this.httpRequest.request({
            method: 'PUT',
            url: '/products-heat-pump/{id}/',
            path: {
                'id': id,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }

    /**
     * @returns ProductHeatPump
     * @throws ApiError
     */
    public productsHeatPumpPartialUpdate({
        id,
        requestBody,
    }: {
        /**
         * A unique integer value identifying this product heat pump.
         */
        id: number,
        requestBody?: PatchedProductHeatPump,
    }): CancelablePromise<ProductHeatPump> {
        return this.httpRequest.request({
            method: 'PATCH',
            url: '/products-heat-pump/{id}/',
            path: {
                'id': id,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }

    /**
     * @returns void
     * @throws ApiError
     */
    public productsHeatPumpDestroy({
        id,
    }: {
        /**
         * A unique integer value identifying this product heat pump.
         */
        id: number,
    }): CancelablePromise<void> {
        return this.httpRequest.request({
            method: 'DELETE',
            url: '/products-heat-pump/{id}/',
            path: {
                'id': id,
            },
        });
    }

}
